import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {liteTemplate} from "@/lib/routes";

const defaultSetRoute = {
    notifications: (route, router, unitId) => {
        if(consts.app.$isDevelopment) console.warn('defaultSetRoute notifications empty', route, router, unitId)
    },
    notificationsEdit: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsEdit', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        let notificationType = route?.params?.notificationType
        let notificationId = route?.params?.notificationId
        router.push({
            name: consts.routerNames.notificationsevents.edit.main,
            params: {
                unitId,
                date,
                notificationType,
                notificationId,
            },
            query: {}
        })
    },
    notificationsCloseEdit: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsCloseEdit', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        let notificationType = route?.params?.notificationType
        let notificationId = route?.params?.notificationId
        router.push({
            name: consts.routerNames.notificationsevents.filter,
            params: {
                unitId,
                date,
                notificationType,
                notificationId,
            },
            query: {}
        })
    },
    notificationsParams: (route, router, date, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsUnitId', route);
            return false
        }
        date = date || route?.params?.date || store.getters.getDateToday
        if(unitId) {
            router.push({
                name: consts.routerNames.notificationsevents.filter,
                params: {
                    unitId,
                    date
                },
                query: {...route.query}
            })
        } else {
            router.push({
                name: consts.routerNames.notificationsevents.date,
                params: {
                    date
                },
                query: {...route.query}
            })
        }
    },
    notificationsId: (route, router, notificationType, notificationId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsId', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        router.push({
            name: consts.routerNames.notificationsevents.filter,
            params: {
                unitId,
                date,
                notificationType,
                notificationId,
            },
            query: {...route.query}
        })
    },
    notificationsPopup: (route, router, notificationType, notificationId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsPopup', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        router.push({
            name: consts.routerNames.notificationsevents.popup.main,
            params: {
                unitId,
                date,
                notificationType,
                notificationId,
            },
            query: {...route.query}
        })
    },
    notificationsFilter: (route, router, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsFilter', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        let notificationType = route?.params?.notificationType
        let notificationId = route?.params?.notificationId
        router.push({
            name: consts.routerNames.notificationsevents.filter,
            params: {
                unitId,
                date,
                notificationType,
                notificationId,
            },
            query: {
                name: filter?.name || undefined,
                type: filter?.type || undefined,
            }
        })
    },
    notificationsEvent: (route, router, notificationEventType, notificationEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn('notificationsEvent', route);
            return false
        }
        let unitId = route?.params?.unitId
        let date = route?.params?.date
        let notificationType = route?.params?.notificationType
        let notificationId = route?.params?.notificationId
        router.push({
            name: consts.routerNames.notificationsevents.filter,
            params: {
                unitId,
                date,
                notificationType,
                notificationId,
                notificationEventType,
                notificationEventXid,
            },
            query: {...route.query}
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.notificationsevents.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.notificationsevents.main+' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.notificationsevents.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
    liteTemplate,
}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'notificationsevents/:pathMatch(.*)?/:noList(no-list)?',
        name: consts.routerNames.notificationsevents.main,
        redirect: to => {
            return {
                name: consts.routerNames.notificationsevents.date,
                params: {
                    ...to.params,
                    date: store.getters.getDateToday,
                }
            }
        },
        meta: {
            list: 'NotificationsEventsList',
            mainRouteName: consts.routerNames.notificationsevents.main,
            showMapInfo: true,
            showMap: true,
            isLimited: false,
            layers: {
                ...consts.defaultSettingsLayers,
                notifications: {visible: true, showInList: true, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/intuit/portal/NotificationsEventsPage.vue'),
        children: [
            {
                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                name: consts.routerNames.notificationsevents.date,
                children: [
                    {
                        path: ':unitId(\\d+)?/:notificationType?/:notificationId?',
                        name: consts.routerNames.notificationsevents.filter,
                        children: [
                            {
                                path: 'edit',
                                name: consts.routerNames.notificationsevents.edit.main,
                                meta: {
                                    mainRouteName: consts.routerNames.notificationsevents.main,
                                    parentRouteName: consts.routerNames.notificationsevents.filter,
                                    blockingRoutesTransitionFromOutside: true,
                                    sectionInfoByRoute: true
                                },
                                props: {
                                    sectionInfoByRoute: () => ({
                                        time: Date.now()
                                    })
                                },
                                components: {
                                    sectionInfoByRoute: () => import('@/components/notifications_events_history/sectionInfo/NotificationsProps.vue')
                                }
                            },
                            {
                                path: 'popup',
                                name: consts.routerNames.notificationsevents.popup.main,
                                meta: {
                                    mainRouteName: consts.routerNames.notificationsevents.main,
                                    parentRouteName: consts.routerNames.notificationsevents.filter,
                                    blockingRoutesTransitionFromOutside: true,
                                    sectionPopupByRoute: true
                                },
                                props: {
                                    sectionPopupByRoute: function (route) {
                                        return {
                                            eventXid: route.params.notificationId
                                        }
                                    }
                                },
                                components: {
                                    sectionPopupByRoute: () => import('@/components/video/control/video-component/VideoComponentView.vue')
                                }
                            }
                        ]
                    },
                ]
            },

        ],
    },
];

export default routes;